import { memo } from 'react';
import { Divider, Flex } from '@chakra-ui/react';
import { useSelector } from 'react-redux';

import { getPlanPageThemeColors } from 'redux/ThemeSlice';

import { PLAN_FILTER_PILL_HEIGHT, PLAN_REVAMP_RADIUS_SM } from '../planPageRevampUi';

import PlanFilterByControl from './PlanFilterByControl';
import PlanGroupByControl from './PlanGroupByControl';

interface Properties {
  refetchRequest: () => void;
}

const PlanFilterGroupPill = ({ refetchRequest }: Properties) => {
  const themeColors = useSelector(getPlanPageThemeColors);

  return (
    <Flex
      h={PLAN_FILTER_PILL_HEIGHT}
      alignItems='center'
      gap={3}
      px={3}
      py='7px'
      border='1px solid'
      borderColor={themeColors.border}
      borderRadius={PLAN_REVAMP_RADIUS_SM}
      bg='white'
      overflow='hidden'
      flexShrink={0}
    >
      <PlanFilterByControl onApplyFilters={refetchRequest} />

      <Divider orientation='vertical' h='22px' borderColor={themeColors.border} flexShrink={0} />

      <PlanGroupByControl />
    </Flex>
  );
};

export default memo(PlanFilterGroupPill);
